"use client";

import { useCallback, useRef, useState } from "react";
import { usePathname, useRouter } from "next/navigation";

import type { Tag as TagType } from "@/themes/ci/blog/types";

import Tag from "./Tag";
const styles = new Proxy({"SearchBar":"SearchBar-90c89","TagsClosed":"TagsClosed-90c89"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

const SearchBar = ({ tags }: { tags: Tag[] }) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [toggle, setToggle] = useState(false);
  const router = useRouter();
  const pathname = usePathname();

  const onKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") {
        if (!inputRef.current) {
          return;
        }

        const value = inputRef.current.value.trim();

        if (value) {
          inputRef.current.value = "";
          const params = new URLSearchParams();
          params.set("page", "1");
          params.set("search", value);
          router.push(`${pathname}?${params.toString()}`);
        }
      }
    },
    [inputRef, router, pathname],
  );

  const onClick = useCallback(() => {
    setToggle((toggle) => !toggle);
  }, [setToggle]);

  const renderedTags = tags.map((tag) => <Tag key={tag.id} tag={tag} />);

  const tagStyle = ["col-12 col-md-8 mt-1", toggle || styles.TagsClosed].join(
    " ",
  );

  return (
    <div className={`row mb-2 ${styles.SearchBar}`}>
      <div className="col">
        <div className="row py-2 align-items-top">
          <div className="col-12 col-md-4 pb-2 pb-md-0">
            <div className="input-group">
              <input
                ref={inputRef}
                onKeyDown={onKeyDown}
                className="form-control border-0"
              />
              <span className="input-group-text border-0 bg-white">
                <i className="fa fa-search" />
              </span>
            </div>
          </div>
          <div className={tagStyle}>Tag filter: {renderedTags}</div>
        </div>
      </div>

      <div className="col-1">
        <button type="button" className="btn text-white" onClick={onClick}>
          {toggle ? (
            <i className="fa fa-caret-up" />
          ) : (
            <i className="fa fa-caret-down" />
          )}
        </button>
      </div>
    </div>
  );
};

export default SearchBar;
